"use client"

import { Component } from "react"

import API, { URL_PATH } from "../../services/API"
import redux from "../../common/Redux"
import routes from "../../routes/URL"
import Table from "../../components/Table"

import Header from "../../components/Header"
import Toast from "../../components/Toast"
import ConfirmationModal from "../../components/ConfirmationModal"

const ColorScheme = {
  buttonColor: "#FFC857",
  bgColor: "#02111B",
  componentColor: "#07070A",
  accentColor: "#BB0A21",
  textColor: "#FFFFFF",
}

class ListVisitScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedRows: [],
      isBulkDeleteConfirmationModalOpen: false,
      version: 0,
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
    }
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  componentDidMount() {
    const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
    if (!hotel) {
        this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
        return;
    }
    // this.fetchData(1);
  }

  hideModal = () => {
    this.setState({ modalVisible: false })
  }

  showDetails = async (id) => {
    const dt = await API(this, "get", URL_PATH.showEnquiry(id))
    console.log(dt)
    this.setState({ modalData: dt, modalVisible: true })
  }

  onDelete = async (item) => {
    const { status, message, data } = await API(this, "post", URL_PATH.deleteEmployee(item.id), {
      employee_id: item.id,
    })
    if (status == "success") {
      this.showToast(message, "success")
      this.setState({ version: Math.random() })
    } else {
      this.showToast(message, "error")
    }
  }

  onEdit = async (item) => {
    this.props.history.push(routes.admin.employees.update(this.props.hotels[0].hotel_slug,item.slug,item.id))
  }

  onView = async (id) => {}

  // Handle selected rows change from Table component
  handleSelectedRowsChange = (rows) => {
    this.setState({ selectedRows: rows })
  }

  // Open bulk delete confirmation modal
  openBulkDeleteConfirmationModal = () => {
    this.setState({ isBulkDeleteConfirmationModalOpen: true })
  }

  // Close bulk delete confirmation modal
  closeBulkDeleteConfirmationModal = () => {
    this.setState({ isBulkDeleteConfirmationModalOpen: false })
  }

  // Bulk delete action
  onBulkAction = async (rows) => {
    const ids = Object.values(rows)
    console.log("Selected IDs:", ids, URL_PATH.deleteBulkEmployees,this.props.selectedHotelId.id)
    try {
      const { status, message, data } = await API(
        this,
        "post",
        URL_PATH.deleteBulkEmployees(this.props.selectedHotelId.id),
        { ids },
      )

      if (status === "success" || status === true) {
        this.showToast(message, "success")
        this.setState({
          version: Math.random(),
          selectedRows: [],
        })
      } else {
        this.showToast(message || "Operation failed", "error")
      }
    } catch (error) {
      this.showToast("An error occurred while processing your request", "error")
      console.error("Error:", error)
    }
  }

  // Handle bulk delete confirmation
  handleBulkDeleteConfirmation = async () => {
    await this.onBulkAction(this.state.selectedRows)
    this.closeBulkDeleteConfirmationModal()
  }

  render() {
    const { users, page, totalPage, perPageItem, modalVisible, selectedRows, isBulkDeleteConfirmationModalOpen } =
      this.state
    // setTimeout(() => window.alert("hello from render"), 1500);
    return (
      <div className="container-fluid">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "15px",
          }}
        >
          <Header title="Employees" button={null} />
          <div>
            {selectedRows.length > 0 && (
              <button
                className="btn mr-2"
                style={{
                  backgroundColor: ColorScheme.accentColor,
                  color: ColorScheme.textColor,
                  marginRight: "10px",
                }}
                onClick={this.openBulkDeleteConfirmationModal}
              >
                <i className="fa fa-trash mr-1" aria-hidden="true"></i> Delete Selected ({selectedRows.length})
              </button>
            )}
            <button
              className="btn"
              style={{
                backgroundColor: ColorScheme.buttonColor,
                color: ColorScheme.componentColor,
                fontWeight: "700",
              }}
              onClick={() => {
                this.props.history.push(routes.admin.employees.create(this.props.hotels[0].hotel_slug))
              }}
            >
              + ADD NEW EMPLOYEE
            </button>
          </div>
        </div>

        <Table
          key={this.state.version}
          api={URL_PATH.listEmployees}
          // onRowClick={this.onView}
          onEdit={
            // this.props.accessControl.includes("employee-update")
            // ?
            this.onEdit
            // : null
          }
          // onView={this.onView}
          deleteText="delete all data related to this employee."
          onDelete={
            // this.props.accessControl.includes("employee-delete")
            //     ?
            this.onDelete
            // : null
          }
          onSelectedRowsChange={this.handleSelectedRowsChange}
          selectedHotelId={this.props.selectedHotelId}
          row={[
            // id, name, email, phone, designation, status
            // {
            //   title: "Sr. No.",
            //   key: "sr_no",
            //   sortable: false,
            //    parseFunction: (value, item, index) => index + 1

            //   // type: "icon",
            // },
            {
              title: "Profile Picture",
              key: "profile_pic",
              sortable: false,
              type: "icon",
            },
            {
              title: "Name",
              key: "name",
              sortable: false,
              // type: "icon",
            },
            {
              title: "Email",
              key: "email",
              sortable: false,
            },
            {
              title: "Phone",
              key: "phone",
              sortable: false,
            },
            {
              title: "Designation",
              key: "designation",
              sortable: false,
            },
            // {
            //     title: "Available",
            //     key: "status",
            //     sortable: true,
            //     type: "switch",
            //     onSwitch: this.onSwitch,
            // },
          ]}
        />

        {/* Bulk Delete Confirmation Modal */}
        <ConfirmationModal
          isOpen={isBulkDeleteConfirmationModalOpen}
          onConfirm={this.handleBulkDeleteConfirmation}
          onCancel={this.closeBulkDeleteConfirmationModal}
          title="Confirm Bulk Deletion"
          message={`Are you sure you want to delete the selected ${selectedRows?.length} employees? All data related to these employees will be deleted.`}
          confirmText="Yes, delete them!"
          cancelText="Cancel"
        />

        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={this.handleCloseToast}
        />
      </div>
    )
  }
}

export default redux(ListVisitScreen)
